import { UIText2 } from '@cian/ui-kit';
import { IconActionMap16 } from '@cian/ui-kit-design-tokens/icons';

import { type FC } from 'react';

import styles from './ListingViewModeSwitcher.css';

interface IListingViewModeSwitcherProps {
  onSwitch: VoidFunction;
}

export const ListingViewModeSwitcher: FC<IListingViewModeSwitcherProps> = ({ onSwitch }) => {
  return (
    <div
      className={styles['listing-view-mode-switcher']}
      data-testid="view-mode-controls.hybrid-mode-switcher"
      role="button"
      onClick={onSwitch}
    >
      <div className={styles['button']}>
        <IconActionMap16 color="icon-main-default" />
        <UIText2 color="text-main-default" fontWeight="bold">
          Показать на карте
        </UIText2>
      </div>
    </div>
  );
};
